// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateDependency_cancelButton__1OeW6"};